import Flickity from 'flickity';
import themeUtils from '../themeUtils';

export default class DynamicTestimonials {
  constructor(section) {
    this.el = section.el;
    this._flickity = this._flickity.bind(this);
    this.container = 'data-testimonials-container';
    this.slide = 'data-testimonial-item';
    this.testimonialsContainer = this.el.querySelector(`[${this.container}]`);
    this.flickity = null;

    this._flickity();
    this._bindEvents();
  }

  onSectionUnload() {
    this.remove();
  }

  remove() {
    window.removeEventListener('resize', themeUtils.debounce(this._flickity, 100));
    this._destroyFlickity();
  }

  _bindEvents() {
    window.addEventListener('resize', themeUtils.debounce(this._flickity, 100));
  }

  _flickity() {
    if (!this.testimonialsContainer) return;

    // If larger than 'small', destroy Flickity and exit
    if (!themeUtils.isSmall()) {
      this._destroyFlickity();
      return;
    }

    // If Flickity is initialised, exit
    if (this.flickity) {
      return;
    }

    this.flickity = new Flickity(this.testimonialsContainer, {
      cellAlign: 'center',
      cellSelector: `[${this.slide}]`,
      contain: true,
      prevNextButtons: false,
      pageDots: false,
    });
  }

  _destroyFlickity() {
    if (this.flickity) {
      this.flickity.destroy();
      this.flickity = null;
    }
  }

  onSectionBlockSelect(block) {
    if (!this.flickity) { return; }

    const { index } = block.el.dataset;

    this.flickity.select(index, true);
  }
}
